module.exports = __webpack_public_path__ + "media/images/emblems/Anieres-coat_of_arms-0523d7e0e8876338045fc869a10fe04b.svg";